export const cssCodingQuizData = [
  {
    module: "Module 1: Introduction to CSS",
    questions: [
      {
        id: "cssc1-1",
        question: "Set the body text color to #333333.",
        description: "Write a CSS rule for the 'body' selector that sets the text color to #333333 to ensure good base contrast across the page.",
        starterCode: "body {\n  /* Your code here */\n  \n}",
        hint: "Target 'body' and set the 'color' property.",
        ariaLabel: "Code editor for setting basic CSS properties.",
        expectedOutput: ""
      }
    ]
  },
  {
    module: "Module 2: Colors, Contrast & Readability",
    questions: [
      {
        id: "cssc2-1",
        question: "Ensure high contrast for warning text.",
        description: "The warning `.alert` class relies on a red background. Set its text color to 'white' to achieve a WCAG compliant contrast ratio over dark red.",
        starterCode: ".alert {\n  background-color: darkred;\n  /* Your code here */\n  \n}",
        hint: "Use the 'color' property mapped to 'white'.",
        ariaLabel: "Code editor to establish accessible alert contrast.",
        expectedOutput: ""
      }
    ]
  },
  {
    module: "Module 3: Typography & Readable Text",
    questions: [
      {
        id: "cssc3-1",
        question: "Set a readable line height.",
        description: "Set the `line-height` of paragraph `<p>` tags to 1.5. This helps individuals with reading disorders safely track from one line to the next.",
        starterCode: "p {\n  font-size: 1rem;\n  /* Your code here */\n  \n}",
        hint: "Write 'line-height: 1.5;'. Do not include units.",
        ariaLabel: "Code editor to improve typography reading tracking.",
        expectedOutput: ""
      }
    ]
  },
  {
    module: "Module 4: Box Model & Layout Basics",
    questions: [
      {
        id: "cssc4-1",
        question: "Apply a protective Box Sizing policy.",
        description: "Ensure that layout scaling doesn't overflow horizontally by setting `box-sizing` to `border-box` universally on the `html` tag.",
        starterCode: "html {\n  /* Your code here */\n  \n}",
        hint: "Use 'box-sizing: border-box;'.",
        ariaLabel: "Code editor to apply global layout constraints.",
        expectedOutput: ""
      }
    ]
  },
  {
    module: "Module 5: Flexbox for Accessible Layouts",
    questions: [
      {
        id: "cssc5-1",
        question: "Distribute elements safely with Flexbox.",
        description: "Enable Flexbox on the `.nav-list` and use `justify-content` set to `space-between` to spread out navigation elements predictably across the header.",
        starterCode: ".nav-list {\n  /* Your code here */\n  \n}",
        hint: "You need two lines: 'display: flex;' and 'justify-content: space-between;'.",
        ariaLabel: "Code editor for building flex headers.",
        expectedOutput: ""
      }
    ]
  },
  {
    module: "Module 6: CSS Grid & Responsive Design",
    questions: [
      {
        id: "cssc6-1",
        question: "Create a Responsive Auto-fitting Grid.",
        description: "Set the `.photo-gallery` to `display: grid`. Then use `grid-template-columns` with `repeat(auto-fit, minmax(200px, 1fr))` so it flows responsively without media queries.",
        starterCode: ".photo-gallery {\n  /* Your code here */\n  grid-gap: 1rem;\n}",
        hint: "Check your spelling on 'grid-template-columns'.",
        ariaLabel: "Code editor for dynamic CSS Grids.",
        expectedOutput: ""
      }
    ]
  },
  {
    module: "Module 7: Focus Styles & Keyboard Visibility",
    questions: [
      {
        id: "cssc7-1",
        question: "Design a high-visibility keyboard Focus ring.",
        description: "When a user targets a `.btn` using their keyboard, give it a prominent outline by targeting `.btn:focus-visible`. Assign it an `outline` of '3px solid blue' and an `outline-offset` of '2px'.",
        starterCode: ".btn:focus-visible {\n  /* Your code here */\n  \n}",
        hint: "Type 'outline: 3px solid blue;' and 'outline-offset: 2px;'.",
        ariaLabel: "Code editor to write focus rings.",
        expectedOutput: ""
      }
    ]
  },
  {
    module: "Module 8: Animations & Reduced Motion",
    questions: [
      {
        id: "cssc8-1",
        question: "Respect OS-level Reduced Motion requests.",
        description: "Use the `@media (prefers-reduced-motion: reduce)` media query. Inside it, write a generic `* { }` selector that sets `animation-duration` to '0.01ms' to instantly disable motion.",
        starterCode: "/* Your code here */",
        hint: "Start with @media (prefers-reduced-motion: reduce) { * { animation-duration: 0.01ms !important; } }",
        ariaLabel: "Code editor to disable animations for vestibular relief.",
        expectedOutput: ""
      }
    ]
  },
  {
    module: "Module 9: CSS for Screen Reader Content",
    questions: [
      {
        id: "cssc9-1",
        question: "Create an 'sr-only' class effectively.",
        description: "Write the `.sr-only` class. Give it `position: absolute;`, `width: 1px;`, `height: 1px;`, and `overflow: hidden;` so it vanishes visually but remains in the HTML DOM.",
        starterCode: ".sr-only {\n  /* Your code here */\n  \n}",
        hint: "Follow the instructions carefully. Elements are squashed to 1x1 pixels and absolutely positioned.",
        ariaLabel: "Code editor to create screen-reader-only text classes.",
        expectedOutput: ""
      }
    ]
  },
  {
    module: "Module 10: Building an Accessible Portfolio",
    questions: [
      {
        id: "cssc10-1",
        question: "Unhide a Skip Link on keyboard focus.",
        description: "The `.skip-link` is off-screen. Provide a `.skip-link:focus` state that sets `top: 0;` and `left: 0;` so it pops onto the screen when a keyboard user tabs to it.",
        starterCode: ".skip-link {\n  position: absolute;\n  top: -100px;\n}\n\n.skip-link:focus {\n  /* Your code here */\n  \n}",
        hint: "Restore its positioning to 'top: 0' and 'left: 0'.",
        ariaLabel: "Code editor for Skip Navigation un-hiding mechanics.",
        expectedOutput: ""
      }
    ]
  }
];
